const Strings = {
  //app
  version: "v",
  versionNo: "1.0.0",
  appversion: "1",
  appname: "Track Mate",
  appletter: "tr",

  //other
  somethingWrong: "Something went wrong",
  noInternet: "No internet, Please try again!",
  homeDir: "/trackmate",
};

export default Strings;
